import { createFileRoute } from "@tanstack/react-router";

import React from "react";
import DEVICE_CONTEXT from "src/context/internal/device";
import { useTranslation } from "react-i18next";
import { EmptyState } from "src/components/base/empty-state";
import { ShieldCheckIcon } from "@heroicons/react/24/solid";
import { AnchorCardList } from "src/components/device-acl-anchor-card";

/**
 * The properties for {@link DeviceOutboundACLs}
 */
export type DeviceOutboundACLsProps = {};

/**
 * Outbound ACLs of a device
 */
function DeviceOutboundACLs(props: DeviceOutboundACLsProps) {
    const [t] = useTranslation("admin-device-view");
    const ctx = React.useContext(DEVICE_CONTEXT);
    const { tags, groups, device_groups } = ctx.device.outbound_rules;

    const isEmpty = tags.length === 0 && groups.length === 0 && device_groups.length === 0;

    if (isEmpty) {
        return (
            <EmptyState
                icon={<ShieldCheckIcon />}
                title={t("heading.no-outbound-rules")}
                description={t("description.no-outbound-rules")}
            />
        );
    }

    return (
        <div className={"flex flex-col gap-6"}>
            <AnchorCardList
                anchors={tags}
                prefix={"tag"}
                href={"/a/tags/$tagId/outbound-acls"}
                params={(anchor) => ({ tagId: anchor.uuid })}
                direction={"outbound"}
                aclAnchor={(anchor) => ({ type: "Tag", value: anchor })}
            />
            <AnchorCardList
                anchors={groups}
                prefix={"group"}
                href={"/a/groups/$groupId/outbound-acls"}
                params={(anchor) => ({ groupId: anchor.uuid })}
                direction={"outbound"}
                aclAnchor={(anchor) => ({ type: "Group", value: anchor })}
            />
            <AnchorCardList
                anchors={device_groups}
                prefix={"device-group"}
                href={"/a/devicegroups/$deviceGroupId/outbound-acls"}
                params={(anchor) => ({ deviceGroupId: anchor.uuid })}
                direction={"outbound"}
                aclAnchor={(anchor) => ({ type: "DeviceGroup", value: anchor })}
            />
        </div>
    );
}

export const Route = createFileRoute("/_admin/a/devices/$deviceId/_device/outbound-acls")({
    component: DeviceOutboundACLs,
});
